import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import i18n from "./utils/i18n.js";
import store from './store'
import "./assets/style/Home.scss";
import Toast from "vue2-toast";
import "vue2-toast/lib/toast.css";
import VueCryptojs from 'vue-cryptojs'
import VueCookie from "vue-cookies";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Loader91 from "loader91";
import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)
// import "../src/assets/css/style.scss";
window._JWT = {}
window.__native_money91 = {}
Vue.use(VueCookie);
Vue.component("loading", Loading);
Vue.use(Loader91);
Vue.config.productionTip = false
Vue.use(VueCryptojs)
Vue.use(Toast, {
  defaultType: "center",
  duration: 2000,
  wordWrap: true,
  width: "400px"
});
// console.log(VueCryptojs);
// window.__native_money91 = {};
// window.serverUrl = 'https://test3.services-money91.com/backend/'
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
